import { Progress, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

const BULK_TOAST_ID = 'spectral-workspace-session-load-bulk';

const buildBulkProgressPercent = (completed: number, total: number) =>
  total > 0 ? Math.round((completed / total) * 100) : 0;

const buildBulkProgressMessage = (completed: number, total: number) => (
  <Stack gap={6}>
    <Text size='xs' c='dimmed'>
      Caricamento dati HR: {completed} di {total} sessioni…
    </Text>
    <Progress
      size='sm'
      value={buildBulkProgressPercent(completed, total)}
      color='blue'
      animated
      striped
    />
  </Stack>
);

const bulkToastBaseOptions = {
  id: BULK_TOAST_ID,
  position: 'bottom-right' as const,
  color: 'blue' as const,
  title: 'Caricamento sessioni',
  loading: true,
  autoClose: false,
  withCloseButton: false,
};

export const showBulkSessionLoadToast = (sessionCount: number) => {
  notifications.show({
    ...bulkToastBaseOptions,
    message: buildBulkProgressMessage(0, sessionCount),
  });
};

export const updateBulkSessionLoadToast = (
  completed: number,
  total: number
) => {
  notifications.update({
    ...bulkToastBaseOptions,
    message: buildBulkProgressMessage(completed, total),
  });
};

export const completeBulkSessionLoadToast = (sessionCount: number) => {
  notifications.update({
    id: BULK_TOAST_ID,
    position: 'bottom-right',
    loading: false,
    color: 'teal',
    title: 'Sessioni pronte',
    message: (
      <Stack gap={6}>
        <Text size='xs'>Dati HR caricati per {sessionCount} sessioni.</Text>
        <Progress size='sm' value={100} color='teal' />
      </Stack>
    ),
    autoClose: 3000,
    withCloseButton: true,
  });
};

export const failBulkSessionLoadToast = (message: string) => {
  notifications.update({
    id: BULK_TOAST_ID,
    position: 'bottom-right',
    loading: false,
    color: 'red',
    title: 'Caricamento sessioni',
    message: (
      <Stack gap={6}>
        <Text size='xs'>{message}</Text>
        <Progress size='sm' value={100} color='red' />
      </Stack>
    ),
    autoClose: 5000,
    withCloseButton: true,
  });
};

export const hideBulkSessionLoadToast = () => {
  notifications.hide(BULK_TOAST_ID);
};
